export const opacityPropertyName = "vind_hidden_property_opacity";
export const zoomPropertyName = "vind_hidden_property_zoom";
export const ZOOM_SHOW_THRESHOLD = 12;
